export enum DIALOG_TYPES {
    LOGOUT_DIALOG = 'LOGOUT_DIALOG',
    SESSION_DIALOG = 'SESSION_DIALOG',
    CONNECTION_DISCONNECT_DIALOG ='CONNECTION_DISCONNECT_DIALOG'
}